import { GetLocationDataActionTypes, GET_LOCATION_DATA_FAILURE, GET_LOCATION_DATA_REQUEST, GET_LOCATION_DATA_SUCCESS, LocationDataState } from "store/reducers/lodgingRequest/getLocationData/types";

const defaultState: LocationDataState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLocationData(state = defaultState, action: GetLocationDataActionTypes): LocationDataState {
  switch (action.type) {
    case GET_LOCATION_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LOCATION_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LOCATION_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};